<!--
  admin-portal-scope no PRÓPRIO root, e não só nos consumidores: o editor
  aparece em três telas (checkin-etiqueta, niimbot-printer-modal e o modal de
  bulk print) e só a primeira vive dentro do shell do anel. Sem a classe aqui,
  as guardas de `@layer components` do styles-tw.css devolveriam o valor
  legado do Bootstrap para as classes colidentes nas outras duas, e o editor
  renderizaria diferente dependendo de quem o abriu.
-->
<div class="admin-portal-scope flex flex-col overflow-hidden rounded-input border border-border bg-card text-card-foreground">
  <!-- Empilha no mobile (canvas em cima, propriedades embaixo), lado a lado a partir de md. -->
  <div class="flex min-h-0 flex-col md:flex-row">
    <!-- ── Canvas ───────────────────────────────────────────────────────── -->
    <div class="relative flex min-w-0 flex-1 flex-col">
      <!-- O canvas tem 400x400 intrínsecos e antes só respeitava a largura, o
           que empurrava rodapé e rótulos para fora em viewport baixa. Com teto
           em dvh e as duas dimensões em auto ele encolhe mantendo a proporção,
           como um <img> — é o que troca a barra de rolagem por uma etiqueta um
           pouco menor. Padding curto no celular pelo mesmo motivo.

           O cursor vai em style inline, e NÃO em utility: onMouseMove escreve
           canvas.style.cursor para distinguir mover de redimensionar, e as
           utilities do anel saem com !important — uma classe cursor-* aqui
           venceria o inline e deixaria tudo em crosshair. -->
      <div class="flex min-h-[160px] flex-1 items-center justify-center bg-muted p-[0.625rem] md:p-5">
        <canvas
          #canvas
          class="block h-auto max-h-[36dvh] w-auto max-w-full bg-white shadow-float [image-rendering:crisp-edges]"
          style="cursor: crosshair"
          (mousedown)="onCanvasMouseDown($event)"
          (mousemove)="onCanvasMouseMove($event)"
          (mouseup)="onCanvasMouseUp()"
          (mouseleave)="onCanvasMouseLeave()"
          (dblclick)="onCanvasDoubleClick($event)"
        ></canvas>
      </div>

      <!-- Edição in loco ao dar duplo clique num texto vindo do ingresso.
           Posição vem por [style] porque é calculada do canvas em runtime. -->
      @if (editingOverlay) {
        <div class="fixed inset-0 z-[2000] cursor-default bg-transparent" (mousedown)="confirmEditingOverlay()"></div>
        <input
          #inlineEditorInput
          type="text"
          class="fixed z-[2001] box-border rounded-[3px] border-2 border-primary bg-white/95 px-1.5 py-0.5 font-[Arial,sans-serif]/[1.2] text-black outline-none shadow-float"
          [style]="{
            left: editingOverlay.rect.left + 'px',
            top: editingOverlay.rect.top + 'px',
            width: editingOverlay.rect.width + 'px',
            minHeight: editingOverlay.rect.height + 'px',
            fontSize: editingOverlay.fontSize + 'px'
          }"
          [(ngModel)]="editingOverlay.value"
          (keydown.enter)="confirmEditingOverlay()"
          (keydown.escape)="cancelEditingOverlay()"
          (blur)="confirmEditingOverlay()"
          (mousedown)="$event.stopPropagation()"
          />
      }

      <!-- ── Barra de ferramentas ──────────────────────────────────────── -->
      <div class="flex shrink-0 flex-wrap items-center gap-1 border-t border-border bg-card px-2.5 py-1.5">
        <button
          type="button"
          hlmBtn
          variant="ghost"
          size="sm"
          class="h-8 gap-1.5 px-2 text-[10pt] normal-case"
          (click)="addTextElement()"
          title="Adicionar texto"
        >
          <ng-icon name="lucideType" size="15px" />
          Texto
        </button>
        <button
          type="button"
          hlmBtn
          variant="ghost"
          size="sm"
          class="h-8 gap-1.5 px-2 text-[10pt] normal-case"
          (click)="addLineElement()"
          title="Adicionar linha"
        >
          <ng-icon name="lucideMinus" size="15px" />
          Linha
        </button>
        <!-- Um botão desabilitado sem motivo é o item que a auditoria pegou:
             o title diz por que, em vez de só apagar. -->
        <button
          type="button"
          hlmBtn
          variant="ghost"
          size="sm"
          class="h-8 gap-1.5 px-2 text-[10pt] normal-case"
          [disabled]="hasQRElement"
          (click)="addQRElement()"
          [title]="hasQRElement ? 'A etiqueta já tem um QR Code' : 'Adicionar QR Code'"
        >
          <ng-icon name="lucideQrCode" size="15px" />
          QR Code
        </button>

        @if (selectedElement) {
          <span class="mx-1 h-5 w-px shrink-0 bg-border" aria-hidden="true"></span>
          <button
            type="button"
            hlmBtn
            variant="ghost"
            size="sm"
            class="size-8 px-0"
            (click)="alignHorizontalCenter()"
            title="Centralizar horizontalmente"
            aria-label="Centralizar horizontalmente"
          >
            <ng-icon name="lucideAlignHorizontalJustifyCenter" size="15px" />
          </button>
          <button
            type="button"
            hlmBtn
            variant="ghost"
            size="sm"
            class="size-8 px-0"
            (click)="alignVerticalCenter()"
            title="Centralizar verticalmente"
            aria-label="Centralizar verticalmente"
          >
            <ng-icon name="lucideAlignVerticalJustifyCenter" size="15px" />
          </button>
        }

        <span class="mx-1 h-5 w-px shrink-0 bg-border" aria-hidden="true"></span>
        <!-- Lixeira, e não um "✕": o ✕ é a convenção de FECHAR, e este botão
             destrói o elemento selecionado sem desfazer. Com os dois na mesma
             tela (o modal tem o seu ✕ de fechar) o glifo emprestado vira uma
             armadilha. Rótulo visível pelo mesmo motivo dos vizinhos. -->
        <button
          type="button"
          hlmBtn
          variant="ghost"
          size="sm"
          class="h-8 gap-1.5 px-2 text-[10pt] normal-case text-destructive hover:text-destructive"
          [disabled]="!selectedElement"
          (click)="deleteSelectedElement()"
          title="Excluir o elemento selecionado"
          aria-label="Excluir o elemento selecionado"
        >
          <ng-icon name="lucideTrash2" size="15px" />
          Excluir
        </button>

        <!-- Rótulo visível: sem ele, "50×30mm" solto na barra não diz que é o
             tamanho da ETIQUETA (e o select não tinha nome acessível nenhum). -->
        <label class="ms-auto flex shrink-0 items-center gap-1.5">
          <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">Etiqueta</span>
          <select
            class="h-8 cursor-pointer rounded-input border border-border bg-card px-2 text-xs text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            [(ngModel)]="selectedPresetIndex"
            (change)="onPresetChange()"
            >
            @for (preset of presets; track preset; let i = $index) {
              <option [value]="i">{{ getPresetTitle(preset) }}</option>
            }
          </select>
        </label>
      </div>
    </div>

    <!-- ── Propriedades ─────────────────────────────────────────────────── -->
    <div
      class="max-h-[250px] w-full shrink-0 overflow-y-auto border-t border-border md:max-h-[400px] md:w-[240px] md:border-t-0 md:border-l"
    >
      @if (!selectedElement) {
        <!-- Sem seleção o painel só dizia "clique em algo". O deslocamento é
             ajuste do PAR impressora+etiqueta, não de um elemento, então este
             é o lugar dele: some quando você está editando um elemento. -->
        <div class="flex flex-col gap-3 p-[0.75rem]">
          <p class="m-0 text-xs text-muted-foreground">
            Clique em um elemento do canvas para editar.
          </p>
          <div class="flex flex-col gap-2 rounded-input border border-border p-[0.625rem]">
            <div class="flex flex-col gap-0.5">
              <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">
                Deslocamento da impressão
              </span>
              <span class="text-[11px] leading-snug text-muted-foreground">
                Só sai no papel; o preview acima não muda. Saiu 4&nbsp;mm à direita? Use −4 em X.
              </span>
            </div>
            <div class="grid grid-cols-2 gap-2">
              <label class="flex flex-col gap-1">
                <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">X (mm)</span>
                <div class="relative">
                  <input hlmInput type="number" step="0.5" class="h-8 pe-8 text-xs"
                    [value]="deslocamentoX"
                    (input)="atualizarDeslocamento('offsetX', $any($event.target).value)" />
                  <span class="pointer-events-none absolute end-2.5 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">mm</span>
                </div>
              </label>
              <label class="flex flex-col gap-1">
                <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">Y (mm)</span>
                <div class="relative">
                  <input hlmInput type="number" step="0.5" class="h-8 pe-8 text-xs"
                    [value]="deslocamentoY"
                    (input)="atualizarDeslocamento('offsetY', $any($event.target).value)" />
                  <span class="pointer-events-none absolute end-2.5 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">mm</span>
                </div>
              </label>
            </div>
          </div>
        </div>
      } @else {
        <!-- Padding em valor arbitrário, e não na escala: o Bootstrap define o
             mesmo nome com outro valor, e emiti-lo faria o tw vencer nas telas
             legadas que ainda o usam. Evita a guarda global (nota (iv) do
             check-tw-collisions). E o nome não pode aparecer nem AQUI: o
             scanner do Tailwind lê o arquivo cru e não entende comentário. -->
        <div class="flex flex-col gap-4 p-[0.75rem]">
          <div class="flex items-center gap-2">
            <span
              class="inline-flex size-[22px] shrink-0 items-center justify-center rounded-[6px] bg-accent text-[11px] font-bold text-accent-foreground"
              aria-hidden="true"
            >
              {{ selectedElement.type === 'qr' ? 'QR' : selectedElement.type === 'line' ? '—' : 'T' }}
            </span>
            <span class="min-w-0 flex-1 truncate text-xs font-semibold">{{ selectedElement.id }}</span>
            <button
              type="button"
              hlmBtn
              variant="ghost"
              size="sm"
              [class]="showAdvanced ? 'size-7 px-0 text-primary' : 'size-7 px-0 text-muted-foreground'"
              (click)="toggleAdvanced()"
              title="Posição e tamanho exatos"
              aria-label="Posição e tamanho exatos"
            >
              <ng-icon name="lucideSettings2" size="14px" />
            </button>
          </div>

          @if (showAdvanced) {
            <div class="grid grid-cols-2 gap-2">
              <label class="flex flex-col gap-1">
                <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">X</span>
                <input hlmInput type="number" class="h-8 text-xs" [value]="selectedElement.x | number:'1.0-0'"
                  (input)="updateElementProperty('x', +$any($event.target).value)" />
              </label>
              <label class="flex flex-col gap-1">
                <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">Y</span>
                <input hlmInput type="number" class="h-8 text-xs" [value]="selectedElement.y | number:'1.0-0'"
                  (input)="updateElementProperty('y', +$any($event.target).value)" />
              </label>
              <label class="flex flex-col gap-1">
                <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">Largura</span>
                <input hlmInput type="number" class="h-8 text-xs" [value]="selectedElement.width"
                  (input)="updateElementProperty('width', +$any($event.target).value)" />
              </label>
              <label class="flex flex-col gap-1">
                <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">Altura</span>
                <input hlmInput type="number" class="h-8 text-xs" [value]="selectedElement.height"
                  (input)="updateElementProperty('height', +$any($event.target).value)" />
              </label>
            </div>
          }

          @if (selectedElement.type === 'text') {
            <label class="flex flex-col gap-1">
              <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">Fonte</span>
              <select
                class="h-8 w-full cursor-pointer rounded-input border border-border bg-card px-2 text-xs text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                [value]="selectedElement.fontFamily || 'Arial'"
                (change)="updateElementProperty('fontFamily', $any($event.target).value)">
                @for (f of availableFonts; track f) {
                  <option [value]="f">{{ f }}</option>
                }
              </select>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">Tamanho</span>
              <div class="relative">
                <input hlmInput type="number" class="h-8 pe-8 text-xs" [value]="selectedElement.fontSize || 12"
                  (input)="updateElementProperty('fontSize', +$any($event.target).value)" />
                <span class="pointer-events-none absolute end-2.5 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">px</span>
              </div>
            </label>

            <div class="flex flex-col gap-1">
              <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">Estilo</span>
              <!-- Um ternário só por botão: duas classes ativa/inativa lado a
                   lado quebram com a inversão de camada do !important. -->
              <div class="flex items-center gap-1 rounded-input bg-muted p-1">
                <button type="button" title="Negrito" aria-label="Negrito"
                  [class]="selectedElement.fontWeight === 'bold'
                    ? 'inline-flex h-7 flex-1 cursor-pointer items-center justify-center rounded-[6px] border-0 bg-card text-foreground shadow-card'
                    : 'inline-flex h-7 flex-1 cursor-pointer items-center justify-center rounded-[6px] border-0 bg-transparent text-muted-foreground'"
                  (click)="updateElementProperty('fontWeight', selectedElement.fontWeight === 'bold' ? 'normal' : 'bold')">
                  <ng-icon name="lucideBold" size="14px" />
                </button>
                <button type="button" title="Itálico" aria-label="Itálico"
                  [class]="selectedElement.fontStyle === 'italic'
                    ? 'inline-flex h-7 flex-1 cursor-pointer items-center justify-center rounded-[6px] border-0 bg-card text-foreground shadow-card'
                    : 'inline-flex h-7 flex-1 cursor-pointer items-center justify-center rounded-[6px] border-0 bg-transparent text-muted-foreground'"
                  (click)="updateElementProperty('fontStyle', selectedElement.fontStyle === 'italic' ? 'normal' : 'italic')">
                  <ng-icon name="lucideItalic" size="14px" />
                </button>
                <span class="h-4 w-px shrink-0 bg-border" aria-hidden="true"></span>
                <button type="button" title="Alinhar à esquerda" aria-label="Alinhar à esquerda"
                  [class]="(selectedElement.textAlign || 'left') === 'left'
                    ? 'inline-flex h-7 flex-1 cursor-pointer items-center justify-center rounded-[6px] border-0 bg-card text-foreground shadow-card'
                    : 'inline-flex h-7 flex-1 cursor-pointer items-center justify-center rounded-[6px] border-0 bg-transparent text-muted-foreground'"
                  (click)="updateElementProperty('textAlign', 'left')">
                  <ng-icon name="lucideAlignLeft" size="14px" />
                </button>
                <button type="button" title="Centralizar" aria-label="Centralizar"
                  [class]="selectedElement.textAlign === 'center'
                    ? 'inline-flex h-7 flex-1 cursor-pointer items-center justify-center rounded-[6px] border-0 bg-card text-foreground shadow-card'
                    : 'inline-flex h-7 flex-1 cursor-pointer items-center justify-center rounded-[6px] border-0 bg-transparent text-muted-foreground'"
                  (click)="updateElementProperty('textAlign', 'center')">
                  <ng-icon name="lucideAlignCenter" size="14px" />
                </button>
                <button type="button" title="Alinhar à direita" aria-label="Alinhar à direita"
                  [class]="selectedElement.textAlign === 'right'
                    ? 'inline-flex h-7 flex-1 cursor-pointer items-center justify-center rounded-[6px] border-0 bg-card text-foreground shadow-card'
                    : 'inline-flex h-7 flex-1 cursor-pointer items-center justify-center rounded-[6px] border-0 bg-transparent text-muted-foreground'"
                  (click)="updateElementProperty('textAlign', 'right')">
                  <ng-icon name="lucideAlignRight" size="14px" />
                </button>
              </div>
            </div>

            <label class="flex cursor-pointer items-center gap-2 text-xs text-foreground">
              <input type="checkbox" class="size-4 cursor-pointer accent-primary"
                [checked]="selectedElement.wrap || false"
                (change)="updateElementProperty('wrap', $any($event.target).checked)" />
              Quebrar texto
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">Origem do dado</span>
              <select
                class="h-8 w-full cursor-pointer rounded-input border border-border bg-card px-2 text-xs text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                [value]="selectedElement.dataSource"
                (change)="updateElementProperty('dataSource', $any($event.target).value)">
                <option value="fixed">Texto fixo</option>
                <option value="name">Nome do participante</option>
                <option value="lote">Nome do lote</option>
                <option value="extra">Campo editável na impressão</option>
              </select>
            </label>

            @if (selectedElement.dataSource === 'fixed' || selectedElement.dataSource === 'extra') {
              <label class="flex flex-col gap-1">
                <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">
                  {{ selectedElement.dataSource === 'fixed' ? 'Valor' : 'Placeholder' }}
                </span>
                <input hlmInput type="text" class="h-8 text-xs"
                  [value]="selectedElement.value || ''"
                  (input)="updateElementProperty('value', $any($event.target).value)" />
              </label>
              <div class="flex flex-wrap gap-1">
                @for (v of variaveisDisponiveis; track v) {
                  <code class="rounded-[6px] bg-muted px-1.5 py-0.5 font-mono text-[10px] text-muted-foreground">{{ v }}</code>
                }
              </div>
            }
          }

          @if (selectedElement.type === 'line') {
            <label class="flex flex-col gap-1">
              <span class="text-xs font-semibold uppercase tracking-[0.04em] text-muted-foreground">Espessura</span>
              <div class="relative">
                <input hlmInput type="number" class="h-8 pe-8 text-xs" min="1" max="20"
                  [value]="selectedElement.height"
                  (input)="updateElementProperty('height', +$any($event.target).value)" />
                <span class="pointer-events-none absolute end-2.5 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">px</span>
              </div>
            </label>
          }

          @if (selectedElement.type === 'qr') {
            <p class="m-0 text-xs leading-relaxed text-muted-foreground">
              O QR é gerado na impressão, com o código do ingresso.
            </p>
          }
        </div>
      }
    </div>
  </div>
</div>
